<template>
    <b-container>
        <b-card :title="$globalStore.translate('password.title')">
            <b-alert variant="danger" dismissible :show="status.length > 0">{{ status }}</b-alert>

            <b-form @submit.prevent="setPassword">
                <b-form-group :label="$globalStore.translate('password.password')" label-for="inputPassword">
                    <b-form-input
                        id="inputPassword"
                        type="password"
                        v-model="password"
                        required
                        placeholder="" />
                </b-form-group>

                <b-form-group :label="$globalStore.translate('password.password.repeat')" label-for="inputPassword2">
                    <b-form-input
                        id="inputPassword2"
                        type="password"
                        v-model="passwordAgain"
                        required
                        placeholder="" />
                </b-form-group>

                <b-button type="submit" variant="primary" class="float-right">{{ 'password.confirm' | translate }}</b-button>
            </b-form>
        </b-card>
    </b-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Password",
        data() {
            return {
                password: '',
                passwordAgain: '',
                status: ''
            }
        },
        methods: {
            setPassword: function () {
                if (!this.password || !this.passwordAgain) {
                    this.status = 'password.empty';
                    return;
                }

                if (this.password !== this.passwordAgain) {
                    this.status = 'password.not.match';
                    return;
                }

                let formData = new FormData();
                formData.append('password', this.password);
                formData.append('token', this.$route.params.token);

                this.status = '';
                this.password = '';
                this.passwordAgain = '';

                axios.post('https://drop.rautec.de/api/user/password', formData).then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('password.request.success', true);

                        let that = this;
                        setTimeout(function () {
                            that.$router.push('/');
                        }, 4000);
                    } else {
                        this.$toastError('password.request.error', true);
                    }
                }).catch(reason => {
                    this.$toastError('password.request.error', true);
                });
            }
        },
        mounted() {
            // TODO: Check for valid token?
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Password.vue